export default __webpack_public_path__ + "static/media/grunge.f270fe50.png";